/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable @typescript-eslint/no-unused-vars */
import { useEffect, useRef, useState } from "react";
import noUiSlider, { target } from "nouislider";
import { useNavigate } from "react-router-dom";
import { Dropdown, ListGroup } from "react-bootstrap";
import User from "../../../../_metronic/assets/images/user.png";
import { io } from "socket.io-client";
import { errorMessage, successMessage } from "../../../../app/utlis/common";
import { FetchOrderStatus } from "../../../../app/redux/features/orderStatus/orderStatusAction";
import { FetchInventoryList } from "../../../../app/redux/features/inventory/inventoryAction";
import { useDispatch, useSelector } from "react-redux";
import { closeNotificationModal, incrementNotificationCount, openNotificationModal, resetNotificationCount } from "../../../../app/redux/features/notifications/notificationSlice";
import clsx from "clsx";
import moment from "moment";
import { openProfileModal } from "../../../../app/redux/features/profile/profileSlice";
import { GetProfileDetails } from "../../../../app/redux/features/profile/profileActions";
import ProfileModal from "../../../partials/modals/ProfileModal";
import { GetNotifications } from "../../../../app/redux/features/notifications/notificationActions";

//  WebSocket instance moved OUTSIDE component to avoid re-creating on re-renders
const SOCKET_URL = process.env.REACT_APP_SOCKET_URL || "http://localhost:9000";
const socket = io(SOCKET_URL, {
  transports: ["websocket"],
  reconnectionAttempts: 5,
  reconnectionDelay: 2000,
});

const HeaderToolbar = () => {
  const navigate = useNavigate();
  const userEmail = localStorage.getItem("email");
  const userId = localStorage.getItem("id");
  const dispatch: any = useDispatch();
  const dropdownRef = useRef<HTMLDivElement>(null);
  const states = useSelector((state: any) => state.notificationsSlice);
  const notificationsList = states?.notifications || [];
  const totalRecord = states?.totalRecord || 0;
  const notificationCount = states?.notificationCount;
  const openNotificationListModal = states?.openNotificationListModal;


  // Slider setup
  useEffect(() => {
    const slider: target = document.querySelector("#kt_toolbar_slider") as target;
    const rangeSliderValueElement: Element | null = document.querySelector("#kt_toolbar_slider_value");

    if (!slider) return;

    slider.innerHTML = "";
    noUiSlider.create(slider, {
      start: [5],
      connect: [true, false],
      step: 1,
      range: { min: [1], max: [10] },
    });

    slider.noUiSlider?.on("update", function (values: any, handle: any) {
      if (rangeSliderValueElement) {
        rangeSliderValueElement.innerHTML = parseInt(values[handle]).toFixed(1);
      }
    });

    return () => {
      slider.noUiSlider?.destroy(); //  Clean up slider when component unmounts
    };
  }, []);

  // WebSocket events
  useEffect(() => {
    socket.on("connect", () => console.log("Connected to WebSocket:", socket.id));
    socket.on("disconnect", (reason) => {
      console.warn("Disconnected from WebSocket:", reason);
      if (reason === "io server disconnect") {
        socket.connect();
      }
    });

    //  Handle barcode-scanned events from IoT Hub
    socket.on("barcode-scanned", async (data) => {
      console.log("Received barcode from IoT Hub:", data);

      if (userId == data?.userId) {
        successMessage("Order and Inventory quantity updated from IOT");
        dispatch(incrementNotificationCount());
        dispatch(GetNotifications({ page: 1, limit: 10 }));

        const currentPath = window.location.pathname;

        if (currentPath === "/barcode") {
          navigate("/order-status");
        }
        else if (currentPath === "/order-status") {
          dispatch(FetchOrderStatus({ page: 1, limit: 10 }));
        } else if (currentPath === "/inventory") {
          dispatch(FetchInventoryList({ page: 1, limit: 10 }));
        }
      }
    });

    socket.on("checkLastActivity", async (data) => {
      console.log("check Last Activity: ", data);

      if (userId == data?.userId) {
        successMessage(data.message);
        dispatch(incrementNotificationCount());
        dispatch(GetNotifications({ page: 1, limit: 10 }));
      }
    });

    socket.on("orderAssigned", async (data) => {
      console.log("orderAssinged socket: ", data);
      console.log("userId", userId);

      if (userId == data?.userId) {
        successMessage(data.message);
        dispatch(incrementNotificationCount());
        dispatch(GetNotifications({ page: 1, limit: 10 }));
      }
    });

    socket.on("negativeInventory", async (data) => {
      console.log("negativeInventory socket: ", data);
      console.log("userId", userId);

      if (userId == data?.userId) {
        successMessage(data.message);
        dispatch(incrementNotificationCount());
        dispatch(GetNotifications({ page: 1, limit: 10 }));
      }
    });

    socket.on("registrationSuccess", async (data) => {
      console.log("Registration Success socket: ", data);

      if (userId == data?.userId) {
        successMessage(data.message);
        dispatch(incrementNotificationCount());
        dispatch(GetNotifications({ page: 1, limit: 10 }));
      }
    });

    socket.on("registrationNotSuccess", async (data) => {
      console.log("Registration Not Success socket: ", data);

      if (userId == data?.userId) {
        errorMessage(data.message);
        dispatch(incrementNotificationCount());
        dispatch(GetNotifications({ page: 1, limit: 10 }));
      }
    });

    socket.on("invalidTestBarcode", async (data) => {
      console.log("Invalid Test Barcode socket: ", data);

      if (userId == data?.userId) {
        errorMessage(data.message);
        dispatch(incrementNotificationCount());
        dispatch(GetNotifications({ page: 1, limit: 10 }));
      }
    });

    socket.on("verifiedTestBarcode", async (data) => {
      console.log("Verified Test Barcode socket: ", data);

      if (userId == data?.userId) {
        successMessage(data.message);
        dispatch(incrementNotificationCount());
        dispatch(GetNotifications({ page: 1, limit: 10 }));
      }
    });
    

    return () => {
      socket.off("checkLastActivity");
      socket.off("barcode-scanned");
      socket.off("connect");
      socket.off("disconnect");
      socket.off("orderAssigned");
      socket.off("negativeInventory");
      socket.off("registrationSuccess");
      socket.off("registrationNotSuccess");
      socket.off("invalidTestBarcode");
      socket.off("verifiedTestBarcode");
    };
  }, [navigate]);

  // Outside click detection
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
        dispatch(closeNotificationModal());
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [dispatch]);

  const handleNotificationIconClick = () => {
    dispatch(resetNotificationCount());
    dispatch(openNotificationModal());
  };

  const handleViewAllClick = () => {
    dispatch(closeNotificationModal());
    navigate("/notifications");
  };

  const handleLogout = () => {
    localStorage.removeItem("token");
    window.location.href = '/login'
  };

  const handleProfileClick = () => {
    dispatch(openProfileModal());
  };


  return (
    <div className="toolbar d-flex justify-content-end pe-3">

      {/* Notification Icon */}
      <div className="position-relative me-4" ref={dropdownRef}>
        <div
          className={clsx(
            "btn btn-icon btn-light-primary btn-custom position-relative"
          )}
          onClick={handleNotificationIconClick}
        >
          <i className="bi bi-bell-fill fs-4 cursor-pointer"></i>
          {notificationCount > 0 && (
            <span className="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger">
              {notificationCount}
            </span>
          )}
        </div>

        {openNotificationListModal && (
          <div
            className="notification-dropdown position-absolute top-100 end-0 mt-2 p-3 bg-white border rounded shadow-lg"
            style={{ width: "300px", marginRight: "25px", zIndex: 1000 }}
          >
            <h5 className="text-center" style={{ color: "#2194FF", fontWeight: "bold", borderBottom: "2px solid #2194FF", paddingBottom: "10px" }}>
              Notifiche ({totalRecord})
            </h5>

            <ListGroup>
              <div className="scroll-y mh-325px my-5 px-2">
                {notificationsList.length > 0 ? (
                  notificationsList.map((notification: any, index: number) => (
                    <div key={`notification-${index}`} className="d-flex flex-stack py-4">
                      <div className="d-flex align-items-center justify-content-between">
                        <div className="mb-0 me-2">
                          <div className="fw-semibold">{notification?.message}</div>
                          <span className="badge-light fs-8">
                            {moment(notification?.createdAt).format("MM/DD/YYYY - hh:mm A")}
                          </span>
                        </div>
                      </div>
                    </div>
                  ))
                ) : (
                  <div className="text-center">Nessuna notifica disponibile</div>
                )}
              </div>
            </ListGroup>

            {notificationsList.length > 0 && (
              <div className="py-3 text-center border-top">
                <button
                  onClick={handleViewAllClick}
                  className="btn btn-color-gray-600 btn-active-color-primary"
                >
                  View All <i className="bi bi-arrow-right fs-5 ps-2" />
                </button>
              </div>
            )}
          </div>
        )}
      </div>

      <div className="innerHeader">
        <Dropdown className="user-dropdown">
          <Dropdown.Toggle id="dropdown-basic">
            <label className="username">{userEmail}</label>{" "}
            <img src={User} alt="User" />
          </Dropdown.Toggle>
          <Dropdown.Menu>
            <Dropdown.Item onClick={handleProfileClick}><strong>Profilo</strong></Dropdown.Item>
            <Dropdown.Divider />
            <Dropdown.Item onClick={handleLogout}><strong>Esci</strong></Dropdown.Item>
          </Dropdown.Menu>
        </Dropdown>
      </div>

      {/* Profile Modal */}
      <ProfileModal />

    </div>
  );
};

export { HeaderToolbar, socket }; //  Export socket if needed in other components
